import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { VendorStoreModel } from '@models/VendorModel';

import { GenericSmartList } from '@components/smart-list/GenericSmartList';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';


@Component({
    selector: 'app-smart-list-store-web',
    templateUrl: './smart-list-store-web.component.html',
    styleUrls: ['./smart-list-store-web.component.scss']
})
export class SmartListStoreWebComponent extends GenericSmartList<VendorStoreModel> implements OnInit, OnChanges {

    @Input() stores: VendorStoreModel[] = [];
    @Input() title: string = '';

    storeSelected: VendorStoreModel;
    showAllStores: boolean = false;

    constructor(public modalService: NgbModal) {
        super();
    }

    ngOnInit() {

        this.source = this.stores?.filter(x => x.name);
    }

    ngOnChanges(changes: SimpleChanges): void {

        for (const propName in changes) {
            if (propName === 'stores') {
                const change = changes[propName];
                if (!change.isFirstChange() && (change.previousValue !== change.currentValue)) {

                    this.source = this.stores?.filter(x => x.name);
                }
            }
        }
    }

    onViewStore(storeModal: any, sourceItem: VendorStoreModel) {

        this.storeSelected = sourceItem;
        this.modalService.open(storeModal, {
            keyboard: true, scrollable: true, centered: false, windowClass: 'modal-full'
        });
    }

    getFormattedStoreHours(startAt: Date, endAt: Date): string {
        if(startAt == null || endAt == null) return 'Cerrado';
        else  return `${moment(startAt).format('h:mm a')} - ${moment(endAt).format('h:mm a')}`;
    }

    public validAllStore() {
        this.showAllStores = !this.showAllStores;
    }
}
